export function forceLightTheme() {
  document.documentElement.classList.remove('dark')
  document.documentElement.classList.add('light')
  document.documentElement.removeAttribute('data-theme')
  document.documentElement.style.colorScheme = 'light'
  try {
    localStorage.setItem('theme', 'light')
  } catch {
    //
  }
}

forceLightTheme()
